module.exports = __webpack_public_path__ + "static/media/promotion_points_datepicker_icon.0338d185.svg";